import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { saveAsJSONFile } from '../../../utils';
import { SimplifiedTableRowActionEvent } from '../../../simplified-table';
import { cloneDeep, isEqual } from 'lodash';
import {
  FormActionSelect,
  FormExportButton,
  FormExportConfig,
} from '../../types';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { transformRawToFormly } from '../../utils';

@Component({
  selector: 'form-viewer',
  templateUrl: './form-viewer.component.html',
  styleUrl: './form-viewer.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FormViewerComponent implements OnChanges, AfterViewInit {
  @HostBinding('class')
  readonly cssClass = 'form-viewer';

  @Input() onlyValidSubmit = true;
  @Input() updateOnChanges = true;
  @Input() showRemoveButton = false;

  @HostBinding('class.form-viewer--disabled-form')
  @Input()
  disableForm = false;

  @Input()
  forceDisableForm = false;

  @Input() payload: any = {};
  @Output() payloadChange = new EventEmitter<any>();

  @Input() formConfig?: FormExportConfig;
  @Input() formFields?: FormlyFieldConfig[];
  @Input() formButtons?: FormExportButton[];

  @Output() payloadSubmit = new EventEmitter<any>();

  @Output() actionSelect = new EventEmitter<FormActionSelect>();

  form = new FormGroup({});
  model = {};

  fieldsFormly: FormlyFieldConfig[] = [];
  buttons: FormExportButton[] = [];

  lastEmittedPayload: any = undefined;

  constructor(private ref: ChangeDetectorRef) {}
  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      console.log('tiemout', this.disableForm);
      if (this.disableForm) {
        this.form.disable();
      } else {
        this.form.enable();
      }
      this.ref.detectChanges();
      this.ref.markForCheck();
    }, 100);

    /*console.log(this.disableForm);
    if (this.disableForm) {
      this.form?.disable();
    } else {
      this.form?.enable();
    }
    this.ref.detectChanges();
    this.ref.markForCheck();*/
    if (this.disableForm) {
      this.form?.disable();
    } else {
      this.form?.enable();
    }
    if (
      Object.keys(changes).length === 1 &&
      changes['payload'] &&
      isEqual(changes['payload'].currentValue, this.lastEmittedPayload)
    ) {
      console.log('Do nothing');
      return;
    }

    this.model = cloneDeep(this.payload);
    const fieldsRaw = this.formConfig?.fields || this.formFields || []; // TODO covnert

    this.fieldsFormly = cloneDeep(
      transformRawToFormly(fieldsRaw, this.forceDisableForm),
    );
    console.log(this.fieldsFormly);
    console.log(this.forceDisableForm);
    this.buttons = cloneDeep(
      this.formConfig?.buttons || this.formButtons || [],
    );
    if (this.disableForm) {
      this.form?.disable();
    } else {
      this.form?.enable();
    }
  }
  ngAfterViewInit() {
    if (this.disableForm) {
      this.form.disable();
    } else {
      this.form.enable();
    }
    this.ref.detectChanges();
    this.ref.markForCheck();
  }

  onSubmit(model: any) {
    if (this.form.valid || !this.onlyValidSubmit) {
      console.log('IsValid', this.form.valid);
      this.payloadSubmit.emit(model);
    }
  }
  onModelChange(model: any) {
    console.log('IsValid', this.form.valid);
    console.log(model);
    if (this.updateOnChanges) {
      this.lastEmittedPayload = cloneDeep(model);
      this.payloadChange.emit(cloneDeep(model));
    }
  }
  onActionButton(button: FormExportButton): void {
    if (button.type === 'submit') {
      return;
    }

    const actionId = button.actionId;
    this.actionSelect.emit({
      actionId: actionId,
      isValid: this.form.valid,
      payload: this.form.getRawValue(),
    });
  }
}
